import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { ArrowRight } from "react-feather"

import Layout from "../components/layout"
//import Image from "../components/image"
import SEO from "../components/seo"
import Tilt from 'react-tilt'
import FAQ from "../components/faq"
import CallToAction from "../components/cta"


const IndexPage = () => {
  const [priceMode, setPriceMode] = useState('monthly');

  return (
    <Layout>
    {
      /*description="ScrapeOwl has simple, transparent pricing. You always know how much you will pay. Get 2 months free by paying for a year in advance. Check out our prices here."*/
    }
      <SEO
        title="Pricing"
        description="ScrapeOwl has simple, transparent pricing. You always know how much you will pay. Check out our prices here."
      />

      <div className="hero">
        <Container>
          <Row>
            <Col md="12" lg="12" className="normal-col text-center">
              <h1 className="minor-header">{/*<span id="discount">30% off</span>*/}Pricing</h1>
              <p style={{ maxWidth: '640px', margin: '0rem auto 3rem' }}>
                Get started with 1000 free credits, no credit card needed.
                {
                  /* For annual plans, you are only charged the cost of 10 months as opposed to 12 months of the year, giving you 2 months free.*/
                }
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {
        /*
        <div className="billing-switcher-container">
          <span className={`billing-switcher ${priceMode == 'monthly' ? 'monthly' : 'yearly'}-billing`}>
            <span id="monthly-label" onClick={() => { setPriceMode('monthly') }}>Monthly</span>
            <span id="yearly-label" onClick={() => { setPriceMode('yearly') }}>Yearly (2 months free)</span>
            <span className="billing-selector"></span>
          </span>
        </div>
        */
      }

      <div className="pricing">

        <div className="feature">
          <Container>
            <Row className="price-row">
              <Tilt className="tilt" options={{
                max: 10,     // max tilt rotation (degrees)
                perspective: 5000,   // Transform perspective, the lower the more extreme the tilt gets.
                scale: 1,      // 2 = 200%, 1.5 = 150%, etc..
                speed: 600,    // Speed of the enter/exit transition
                transition: true,   // Set a transition on enter/exit.
                axis: "y",   // What axis should be disabled. Can be X or Y.
                reset: true    // If the tilt effect has to be reset on exit.
              }} >
                <Col md="12" lg="6" className="price-col mb-5">
                  <h2>Startups</h2>
                  <div className="price">
                    <div className="value">
                      <span className="number">
                        29
                        <span className="term">/month</span>
                      </span>
                    </div>
                  </div>
                  <p>Quickly build your project or MVP using our API. Set custom headers, cookies, inject javascript and more!</p>

                  <ul className="plan-quotas">
                    {
                      priceMode == 'monthly' &&
                      <li>250,000 API credits</li>
                    }
                    {
                      priceMode == 'yearly' &&
                      <li>3,000,000 API credits</li>
                    }
                    <li>10 Concurrent Requests</li>
                  </ul>

                  <ul className="plan-features">
                    <li>Parse to Get Elements</li>
                    <li>Rotating Proxies</li>
                    <li>Premium Proxies</li>
                    <li>Geolocation</li>
                    <li>Javascript Rendering</li>
                  </ul>

                  <ul className="plan-unique-features">
                    <li>Best Effort SLA</li>
                    <li>Email Support (response within 24 hours)</li>
                  </ul>
                  <a className="plan-price black-button" href="https://app.scrapeowl.com/register">
                    Start Free Trial
                    {
                      priceMode == 'monthly' && false  && 
                      <React.Fragment>$20/month (normally $29)</React.Fragment>
                    }
                    {
                      priceMode == 'yearly' && false  && 
                      <React.Fragment>$240/year (normally $290)</React.Fragment>
                    }
                    {
                      priceMode == 'monthly' && false && 
                      <React.Fragment>$29/month (normally $89)</React.Fragment>
                    }
                    {
                      priceMode == 'yearly' && false && 
                      <React.Fragment>$290/year (normally $890)</React.Fragment>
                    }
                  </a>
                </Col>
              </Tilt>

              <Tilt className="tilt" options={{
                max: 10,     // max tilt rotation (degrees)
                perspective: 5000,   // Transform perspective, the lower the more extreme the tilt gets.
                scale: 1.005,      // 2 = 200%, 1.5 = 150%, etc..
                speed: 600,    // Speed of the enter/exit transition
                transition: true,   // Set a transition on enter/exit.
                axis: "y",   // What axis should be disabled. Can be X or Y.
                reset: true    // If the tilt effect has to be reset on exit.
              }} >
                <Col md="12" lg="6" className="businesses price-col mb-5">
                  <h2>Businesses</h2>
                  <div className="price">
                    <div className="value">
                      <span className="number">
                        99
                        <span className="term">/month</span>
                      </span>
                    </div>
                  </div>
                  <p>Quickly build your project or MVP using our API. Set custom headers, cookies, inject javascript and more!</p>

                  <ul className="plan-quotas">
                    {
                      priceMode == 'monthly' &&
                      <li>1,000,000 credits</li>
                    }
                    {
                      priceMode == 'yearly' &&
                      <li>12,000,000 credits</li>
                    }
                    <li>25 Concurrent Requests</li>
                  </ul>

                  <ul className="plan-features">
                    <li>Parse to Get Elements</li>
                    <li>Rotating Proxies</li>
                    <li>Premium Proxies</li>
                    <li>Geolocation</li>
                    <li>Javascript Rendering</li>
                  </ul>

                  <ul className="plan-unique-features">
                    <li>Guaranteed SLA</li>
                    <li>Priority Support (response within 12 hours including weekends)</li>
                  </ul>
                  <a className="plan-price black-button" href="https://app.scrapeowl.com/register">
                    Start Free Trial
                    {
                      priceMode == 'monthly' && false &&
                      <React.Fragment>$69/month (normally $99)</React.Fragment>
                    }
                    {
                      priceMode == 'yearly' && false &&
                      <React.Fragment>$690/year (normally $990)</React.Fragment>
                    }
                    {
                      priceMode == 'monthly' && false &&
                      <React.Fragment>$99/month (normally $199)</React.Fragment>
                    }
                    {
                      priceMode == 'yearly' && false &&
                      <React.Fragment>$990/year (normally $1990)</React.Fragment>
                    }
                  </a>

                </Col>
              </Tilt>

            </Row>
          </Container>
          <Container>

            <Row noGutters>
              <Col md="12" lg="12" className="custom-col mb-5">
                <h3>Need a Custom Plan?</h3>
                <h3>
                  <a href="mailto:sales@scrapeowl.com" className="secondary-button">
                    <span className="button-text">Contact us</span>
                    <ArrowRight className="titular-arrow" />
                  </a>
                </h3>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* <Container className="continuity">

        <h2>*Continuity Guarantee</h2>
        <p>
        We take your trust and business seriously and are committed to ensuring that our service remains available for as long as you need it if you are on an annual business plan or higher.
        By securing these contracts, you also help make the service available to indie developers on monthly plans. We are not venture funded and therefore have no reason to shutdown ScrapeOwl at any point.
        </p>

        </Container> */}

      <FAQ />

      <CallToAction />

    </Layout>
  )
}

export default IndexPage
